export async function scheduleMorningReminder(date: Date) {}

export async function scheduleReminder(date: Date) {}

export async function scheduleReminders({
  excludeToday,
}: {
  excludeToday?: boolean;
}) {}
